import { Injectable } from '@angular/core';

import { PatientService } from '../../services/patient.service';

@Injectable()
export class VitalService extends PatientService {

    public modelPath = 'patient/vitals';

    getBodyDatas () {
        return {
            columns: [{
                data: 'vital_id',
                name: 'vital_id',
                searchable: false,
                orderable: false,
                search: {
                    value: '',
                    regex: false
                }
            }, {
                data: 'encounter_id',
                name: 'encounter_id',
                searchable: true,
                orderable: true,
                search: {
                    value: '',
                    regex: false
                }
            }],
            draw: 1,
            length: 10,
            order: [
                {
                    column: 0,
                    dir: 'asc'
                }
            ],
            search: {
                value: '',
                regex: false
            },
            start: 0
        };
    }

    getPatientVitalAccesses (optionParams) {
        return this.httpService.getMethod(`${this.modelPath}/check_vital_access`, optionParams);
    }

    getGraphDatas (optionParams) {
        return this.httpService.getMethod(`${this.modelPath}/get_vitals_graph`, optionParams);
    }

    getVitalUnseenCount (optionParams) {
        return this.httpService.getMethod(`${this.modelPath}/get_vitals_count_by_patient`, optionParams);
    }

    setVitalSeen (optionParams) {
        return this.httpService.postMethod(`${this.modelPath}/seen_vitals`, optionParams);
    }

    getGraphHighlightDatas (optionParams?) {
        return this.httpService.getMethod(`${this.modelPath}/get_vital_graph_highlight_options`, optionParams);
    }
}
